'use client';

import { VoteType } from '@prisma/client';
import { useEffect, useMemo, useState } from 'react';
import type { SuggestionSeed } from '../../../types/shared';
import { useTourismItemEvents, type GlobalRealtimeEvent } from '../contexts/TourismGlobalEvents';
import { SuggestionCard } from './SuggestionCard';

type Props = {
  suggestion: SuggestionSeed;
  myVote: VoteType | null;
  onCardClick: () => void;
  onVote: (voteType: VoteType) => void;
};

export function SuggestionCardLive({ suggestion, myVote, onCardClick, onVote }: Props) {
  // ✅ подписка только на события этого suggestion.id
  const itemEvent = useTourismItemEvents(suggestion.id) as GlobalRealtimeEvent | null;

  // начальные цифры — берём из seed (или 0)
  const initial = useMemo(
    () => ({
      likes: suggestion.initialLikes ?? 0,
      dislikes: suggestion.initialDislikes ?? 0,
    }),
    [suggestion.initialLikes, suggestion.initialDislikes],
  );

  const [counts, setCounts] = useState(initial);

  // если пришёл новый seed (смена страницы/фильтра) — синхронизируем
  useEffect(() => {
    setCounts(initial);
  }, [initial]);

  // ✅ обновляем только если это VOTE_UPDATE для suggestionId
  useEffect(() => {
    if (!itemEvent) return;
    if (itemEvent.type !== 'VOTE_UPDATE') return;

    const { suggestionId, likes, dislikes } = itemEvent.payload as {
      suggestionId?: string;
      likes: number;
      dislikes: number;
    };

    if (!suggestionId || suggestionId !== suggestion.id) return;

    setCounts((prev) => {
      if (prev.likes === likes && prev.dislikes === dislikes) return prev;
      return { likes, dislikes };
    });
  }, [itemEvent, suggestion.id]);

  return (
    <SuggestionCard
      suggestion={{
        ...suggestion,
        // 🔥 теперь карточка всегда рисует актуальные цифры
        initialLikes: counts.likes,
        initialDislikes: counts.dislikes,
      }}
      myVote={myVote}
      onCardClick={onCardClick}
      onVote={onVote}
    />
  );
}
